module.exports = __webpack_public_path__ + "img/signup-cover-image.17a13b30.jpg";